'use strict';

export default class LoginController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  submitted = false;
  AuthSvc;
  $state;

  constructor(AuthSvc, $state, ToastrSvc) {
    // redirect to main if already logged in
    AuthSvc.isLoggedIn(function(loggedIn) {
      if(loggedIn) {
        $state.go('main');
      }
    });
    this.AuthSvc = AuthSvc;
    this.$state = $state;
    this.ToastrSvc = ToastrSvc;
  }

  login(form) {
    this.submitted = true;

    if(form.$valid) {
      this.AuthSvc.login({
        email: this.user.email,
        password: this.user.password
      })
        .then(() => {
          // Logged in, redirect to home
          this.ToastrSvc.success('Login Successful');
          // this.$state.go('main');
        })
        .catch(err => {
          this.submitted = false;
          this.ToastrSvc.error(err.message);
        });
    }
  }
}

LoginController.$inject = ['AuthSvc', '$state', 'ToastrSvc'];
